import React from "react";
import { useState, useEffect, useMemo } from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import { useCurrentUser } from "@queries";
import { useOrganizations } from "@queries/organization";

export function OrganizationDropdownList({
  data,
  className,
  onOrgSelected,
  selectedOrg,
  orgCode,
}) {
  const currentUser = useCurrentUser();
  const effectiveOrgCode = orgCode ?? currentUser?.organizationCode;
  
  const { data: storeOrganizations = [] } = useOrganizations(effectiveOrgCode, {
    enabled: !!effectiveOrgCode && !data,
  });

  const organizations = useMemo(() => {
    return data || storeOrganizations;
  }, [data, storeOrganizations]);

  return (
    <Dropdown
      className={className}
      selected={selectedOrg}
      onOptionSelected={onOrgSelected}
      disabled={!organizations}
    >
      <DropdownButton
        placeholder={"Select an organization..."}
        icon={selectedOrg?.icon}
        required
      >
        {selectedOrg?.name}
      </DropdownButton>
      <DropdownItems>
        {organizations?.map((organization) => (
          <DropdownItem key={organization.id} value={organization}>
            {organization.name}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
}
